import React, { useState } from 'react';
import PropTypes from 'prop-types';
import YouTube from 'react-youtube';
import './styles.css';

const BUTTON_SETTINGS = {
  display: false,
  button: true,
};

function ContentVideo({ url, onPauseVideo, onEndVideo }) {
  const [{ display, button }, setDisplay] = useState(BUTTON_SETTINGS);
  const urlVideo = url.split('=');

  return (
    <div className="content-video">
      {button && (
        <button
          type="button"
          className="button-select-video"
          onClick={() => setDisplay({ display: true, button: false })}
        >
          Veja o vídeo
        </button>
      )}
      {display && (
        <YouTube
          videoId={urlVideo[1]}
          opts={{
            height: '200px',
            width: '100%',
            playerVars: {
              autoplay: 1,
            },
          }}
          className="video"
          onPause={() => onPauseVideo()}
          onEnd={() => onEndVideo()}
        />
      )}
    </div>
  );
}

ContentVideo.propTypes = {
  url: PropTypes.string.isRequired,
  onPauseVideo: PropTypes.func.isRequired,
  onEndVideo: PropTypes.func.isRequired,
};

export default ContentVideo;
